import { render } from "./CallStage.vue.js?vue&type=template&id=6f950dfb!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CallStage.vue?vue&type=template&id=6f950dfb"
import script from "./CallStage.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CallStage.vue?vue&type=script&lang=js"
export * from "./CallStage.vue.js?vue&type=script&lang=js!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CallStage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/apps/video-engine/components/video-call/stage/CallStage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f950dfb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f950dfb', __exports__)) {
    api.reload('6f950dfb', __exports__)
  }
  
  module.hot.accept("./CallStage.vue.js?vue&type=template&id=6f950dfb!=!../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CallStage.vue?vue&type=template&id=6f950dfb", () => {
    api.rerender('6f950dfb', render)
  })

}


export default __exports__